export default "__VITE_ASSET__BsDj_wjD__"